import h from 'react-hyperscript';
import './Form.scss';
import {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {subhead} from 'Components/Typography/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

const styles = (theme) => ({
  root: {
    'color': '#80868b',
    '&:hover': {
      color: '#1a73e8',
    },
    '&$checked': {
      color: '#1a73e8',
    },
  },
  checked: {},
});

class RadioGroupVertical extends Component {
  render() {
    const {props} = this;
    return (
      h('div', {className: 'form-group form-group__radio--vertical'}, [
        h(subhead, {key: 0}, props.title),

        h(RadioGroup, {
          key: props.id,
          id: props.id,
          name: props.name,
          value: this.props.value,
          onChange: props.onChange,
          className: 'radio-group',
        }, [

          props.content.map((radio) => (
            h(FormControlLabel, {
              key: radio.id,
              value: radio.value,
              label: radio.title,
              control: h(Radio, {
                classes: {
                  root: props.classes.root,
                  checked: props.classes.checked,
                },
              }, null),
            })
          )),
        ]),
      ])
    );
  }
}
export default withStyles(styles)(RadioGroupVertical);
